import React from 'react'

const MyFolder = () => {
  return (
    <div className='mt-[10%] md:mt-[4%]'>MyFolder</div>
  )
}

export default MyFolder